import Portfolio1 from "../assets/projects/aevent.png";
import Portfolio2 from "../assets/projects/sova-serve.png";
import Portfolio3 from "../assets/projects/currinda.png";
import Portfolio4 from "../assets/projects/priceOye.png";

const projectData = [
  {
    id: 1,
    title:
      "Priceoye is Pakistan No.1 marketplace for buying original mobile phones and electronics. Priceoye is Pakistan most trusted online store and offers the lowest prices.",
    image: Portfolio4,
    link: "https://priceoye.pk/",
  },
  {
    id: 2,
    title:
      "AEvent is the leading event and communications automation platform for digital marketing professionals and businesses who manage online events, digital marketing campaigns, and training presentations.",
    image: Portfolio1,
    link: "https://aevent.com/",
  },
  {
    id: 3,
    title:
      "Event and abstract management software that helps event managers efficiently manage registrations and abstracts within one integrated platform.",
    image: Portfolio3,
    link: "https://currinda.com/",
  },
  {
    id: 4,
    title:
      "NovaServe is a clean, responsive HTML/CSS business landing page template built for startups, SaaS, and agencies.It's fast, lightweight, and fully responsive — perfect for showcasing your product or service.",
    image: Portfolio2,
    link: "https://nova-serve.netlify.app/",
  },
];

export default projectData;
